namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmAgendaFunkce extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmAgendaFunkceReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmAgendaFunkceObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmAgendaFunkceObj());
            this.detailObj.createBase({
                contentName: "detailAdmAgendaFunkce",
                contentCaption: "jres:33000770",  //RC 33000770 : Agenda ISZR přiřazená funkci
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmAgendaFunkce", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmAgendaFunkceObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmAgendaFunkceReadDto> {
        isPovolenaEvidenceOP: boolean;

        create() {

        }

        textPopis(): string | undefined | null {
            return `${this.data.agenda} - ${this.data.ixs_fun_txt}`
        }

        setSxsDetail(): string {
            return `${this.data.ixs_fun}#${this.data.agenda}#`
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmAgendaFunkceSaveDto, close: boolean) {
            //data.NewRecord = this.options.newRecord;
            //(this.cnt.isl.AdmAgendaFunkce.upsert({ data: data }).get() as any).done((output) => {
            //    if (output.result.kind === Utils.GOperationResultKind.Success) {
            //        this.pendingAction("actSave", true)
            //        this.data = output.data;
            //        this.metadata = this.data.MetaData;
            //        this.updateGridBase().done(() => {
            //            this.showSuccessSave(close);
            //            if (close == true) {
            //                this.closeAction(true).done(() => { this.cnt.close() });
            //            } else
            //                this.reloadDataBase();
            //        })
            //    } else {
            //        this.checkErrors(output.result.errors)
            //        this.pendingAction("actSave", false)
            //    }
            //}).fail((err) => {
            //    this.pendingAction("actSave", false)
            //})
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmAgendaFunkce", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmAgendaFunkce.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.MakeSelectField("agenda", Gordic.Prefabs.Select.szrsage(), {
                model: "model.agenda=value.agenda",
                flag: this.createFlagNemenne(),
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
            });
            this.MakeSelectField("ixs_fun", Gordic.Prefabs.Select.ginsfun(), {
                model: "model.ixs_fun=value.ixs_fun",
                flag: this.createFlagNemenne(),
                serverFilters: {
                    aktivita: [100, 300, 500, 600, 900]
                }
            });
            this.MakeBoolField("s_prist_aiseo")
            this.MakeBoolField("s_prist_isep")
            this.MakeBoolField("s_prist_aisc")
            if (this.isPovolenaEvidenceOP == true)
                this.MakeBoolField("s_prist_aiseop")
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}